export const CLAUDE_PROXY_URL        = import.meta.env.VITE_CLAUDE_PROXY_URL;
export const SQL_WRITER_URL          = import.meta.env.VITE_SQL_WRITER_URL;
export const SQL_READER_URL          = import.meta.env.VITE_SQL_READER_URL;
export const TURNOVER_WRITER_URL     = import.meta.env.VITE_TURNOVER_WRITER_URL;
export const HUBSPOT_PROXY_URL       = import.meta.env.VITE_HUBSPOT_PROXY_URL;
export const CONTRACT_ANALYSIS_URL   = import.meta.env.VITE_CONTRACT_ANALYSIS_URL;
export const CONTRACT_COMPLETE_URL   = import.meta.env.VITE_CONTRACT_COMPLETE_URL;
export const SCHEDULE_ANALYSIS_URL     = import.meta.env.VITE_SCHEDULE_ANALYSIS_URL;
export const CORRESPONDENCE_API_URL    = import.meta.env.VITE_CORRESPONDENCE_API_URL;
export const TAKEOFF_ANALYSIS_URL      = import.meta.env.VITE_TAKEOFF_ANALYSIS_URL;
// Estimating Assistant standalone document review (chunked pipeline, hosted in
// cs-est-takeoff-api/assistant-review). Kicks off a background job; poll + fetch
// the result via sp_GetAssistantReviewStatus / sp_GetAssistantReviewResult.
export const ASSISTANT_REVIEW_URL      = import.meta.env.VITE_ASSISTANT_REVIEW_URL;
// Bid Package "Analyze bid documents" (chunked pipeline, hosted in
// cs-est-takeoff-api/bid-package-review). Same 202-kickoff + status-poll shape
// as ASSISTANT_REVIEW_URL, but reads a whole SharePoint folder of documents and
// persists the result per-project (sp_GetBidPackageReviewStatus/Result) rather
// than per-browser-session.
export const BID_PACKAGE_REVIEW_URL    = import.meta.env.VITE_BID_PACKAGE_REVIEW_URL;
// Layout Canvas "snap to real wall" — synchronous whole-page wall-line
// lookup (hosted in cs-est-takeoff-api/wall-segments), not a 202/poll job
// like the other takeoff-api endpoints above. Returns available:false for a
// raster/scanned or uncalibrated sheet; the canvas falls back to its
// existing room-to-room snapping in that case.
export const WALL_SEGMENTS_URL         = import.meta.env.VITE_WALL_SEGMENTS_URL;
// Count by example — find repeats of one example symbol on a chosen drawing
// (cs-est-takeoff-api/symbol-sweep, one synchronous call per drawing). Same
// function app and host key as wall-segments. Unset = the feature says it is
// not configured; nothing else is affected.
export const SYMBOL_SWEEP_URL          = import.meta.env.VITE_SYMBOL_SWEEP_URL;
// Help form -> GitHub issue (cs-est-hubspot-api/github-issue). Called right after a report is saved; unset or
// failing never affects the report itself (docs/implementation/GITHUB_TRACKER.md).
export const GITHUB_ISSUE_URL          = import.meta.env.VITE_GITHUB_ISSUE_URL;
// Private blob container holding drawing files (https://estassist.blob.core.windows.net/drawings). Not a secret —
// access is each user's own Entra token + RBAC. Unset = drawing storage is off and drawings stay as they are today.
export const DRAWINGS_CONTAINER_URL = import.meta.env.VITE_DRAWINGS_CONTAINER_URL;
